{
  "pt": {
    "proposal": {
      "actions": {
        "addDescription": "Adicionar descrição",
        "addDocuments": "Adicionar documentos",
        "addSubchoiceList": "Lista de subescolhas",
        "addSubchoices": "Subescolhas",
        "approve": "Aceitar",
        "cancel": "Cancelar",
        "choice": {
          "collapse": "Recolher escolhas",
          "delete": "Eliminar opção",
          "edit": "Editar escolha",
          "expand": "Expandir descrições"
        },
        "choice_list": {
          "delete": "Eliminar a lista de opções"
        },
        "createNew": "Criar uma nova proposta",
        "deleteDescription": "Eliminar a descrição",
        "deleteDocuments": "Remover documentos",
        "delete_documents": "Eliminar documento | Eliminar documentos",
        "delete_proposal": "Eliminar proposta",
        "delete_proposal_templates": "Eliminar modelo de proposta",
        "dontShare": "Ainda não é necessário partilhar",
        "duplicate": "Duplicado",
        "edit": "Editar",
        "generatePDF": "Gerar PDF",
        "new": "Proposta",
        "newProposalCustomer": "Nova proposta",
        "publish": "Publicar",
        "reject": "Anular a aprovação",
        "save": "Guardar",
        "share": "Partilhar",
        "shareWithProjectPartners": "Partilhar documentos com os parceiros do projeto...",
        "share_units": "Partilhar com as unidades",
        "signAndApprove": "Assinar e aprovar a proposta",
        "signElectronically": "Ou assinar eletronicamente",
        "steps": {
          "collapse": "Recolher etapas",
          "expand": "Expandir etapas"
        },
        "stop_template_sync": "Parar a sincronização com o modelo",
        "submit": "Enviar",
        "uploadAndApprove": "Carregar e aprovar a proposta",
        "uploadSignableDocument": "Carregar documento assinado para aprovação"
      },
      "attributes": {
        "amount_gross": "Oferta bruta",
        "amount_net": "Oferta líquida",
        "choice_lists": {
          "description": "Descrição",
          "name": "Nome"
        },
        "choices": {
          "description": "Descrição",
          "images": "Imagens",
          "name": "Nome",
          "price_gross": "Preço bruto do artigo",
          "price_net": "Preço líquido do artigo",
          "quantity": "Quantidade",
          "quantity_fixed": "Quantidade fixa",
          "quantity_max": "Máximo",
          "quantity_min": "Mínimo",
          "quantity_not_fixed": "Deixar o cliente preencher a quantidade",
          "selected_default": "Sempre selecionado",
          "total_price_gross": "Preço total bruto",
          "total_price_net": "Total líquido"
        },
        "description": "Como descreveria esta proposta?",
        "documents": "Adicionar documentos",
        "name": "Nome",
        "subtitle": "Isto facilita a consulta por outros",
        "title": "Dê um título à sua proposta",
        "type": {
          "choices": "Lista de seleção",
          "fixed": "Oferta fixa"
        },
        "vat_percentage": "IVA %"
      },
      "labels": {
        "accepted": "Aceite",
        "addExtraBudget": "Adicionar orçamento extra",
        "already_approved": "Esta proposta já foi aprovada.",
        "amount_net_total": "Oferta líquida total",
        "amount_total": "Oferta bruta total",
        "approve": "Aprovar {name}",
        "approved": "Aprovado",
        "approvedDate": "Aprovado {date}",
        "ask_client_to_undo": "Não é possível editar uma proposta aprovada. Contacte {client} para anular a aprovação primeiro.",
        "batchProposalsTemplate": "<p>Esta proposta será criada para {units_count} unidade(s).</p></br><p>Como esta proposta será criada para várias unidades, criámos um modelo a partir dela. Pode encontrar este modelo no separador \"Modelos de proposta\".</p></br><p>Os modelos facilitam a edição ou eliminação de todas as propostas que são partilhadas com este modelo.</p>",
        "batchProposalsWarning": "Esta proposta será criada para {units_count} unidades. Se tiveres de fazer alterações mais tarde, terás de editar cada uma delas separadamente.",
        "budget": "Orçamento",
        "builder": {
          "can_select_multiple": "Pode selecionar vários",
          "item": "Item",
          "multiple_choices_possible": "Múltiplas escolhas possíveis",
          "must_choose_item": "Deve escolher a opção",
          "options": "Escolhas",
          "section": "Lista de seleção",
          "step": "Etapa",
          "step_basic": "Informações de base",
          "step_details": "Detalhes",
          "step_documents": "Documentos",
          "step_internal": "Informações internas",
          "step_visibility": "Partilhar com"
        },
        "by": "por",
        "choice_lists": {
          "add_another": "Adicionar outra lista de opções",
          "create": "Criar listas de seleção de propostas",
          "empty_help": "Comece por adicionar a(s) sua(s) primeira(s) lista(s) de opções. As listas de opções agrupam escolhas para um item específico, por exemplo, \"ladrilhos para o chão\". Depois de ter adicionado listas de opções, pode adicionar uma ou mais opções.",
          "selected": "Selecionado"
        },
        "choices": {
          "add_another": "Adicionar outra opção",
          "create": "Adicionar opções a {choiceListName}",
          "optional": "facultativo",
          "selected_default": "Esta opção será sempre selecionada e o preço será automaticamente calculado no preço total. O cliente não poderá anular a seleção desta opção.",
          "subtotal": "Subtotal"
        },
        "closed": "Esta decisão está agora encerrada. Já não é possível aprovar uma proposta.",
        "createProposal": "Criar proposta",
        "createProposals": "Criar proposta",
        "createdBy": "Criado por {uploader}",
        "customer": "Cliente",
        "customerHasNotSelectedYet": "O cliente ainda não seleccionou",
        "customer_name_confirm": "Escrever <i><b>{customerName}</b></i> para aceitar esta proposta.",
        "customer_name_proceed": "Digite <i><b>{customerName}</b></i> para continuar.",
        "customer_offer": "Oferta do cliente",
        "customers": "Clientes",
        "decision_not_interested": "A decisão está marcada como não interessada.",
        "definedPerUnit": "Definido por unidade",
        "delete_proposal_template": "<p>Se você excluir este modelo, todas as propostas sincronizadas também serão excluídas.<br>Se você não quiser que isso aconteça, use a opção abaixo.</p>",
        "depends_on_customer_input": "Depende do contributo do cliente",
        "documentsRequireSignature": "O cliente precisa de assinar documentos",
        "documents_shared_partners": "Apenas os documentos da proposta são partilhados com os parceiros do projeto.",
        "duplicating": "Duplicação",
        "edit": "Editar",
        "editNotAllowed": "Não é permitido editar ou apagar uma proposta aprovada. Anule primeiro a aprovação antes de a editar.",
        "editProposal": "Editar proposta",
        "excl%VAT": "excl. {vat}% IVA",
        "exclVAT": "sem IVA",
        "export_documents": "Exportar documentos",
        "extraBudget": "Orçamento suplementar",
        "fractions_sent_count_header": "Não é possível criar uma proposta!",
        "fractions_sent_count_message": "As prestações baseadas nesta decisão já foram enviadas. Por favor, altere estas prestações para rascunho primeiro para continuar.",
        "full_prices": "Utilizar preços completos. O Ziggu irá gerar automaticamente actualizações com base no orçamento das decisões",
        "generatingPDF": "Geração de PDF",
        "has_requested_changes": "Já existe um pedido de alteração pendente para esta proposta.",
        "hideDetails": "Ocultar detalhes",
        "installments_connected": "Existem prestações ligadas a esta proposta.",
        "internalNote": "Nota interna",
        "internalNoteSubtitle": "Esta nota só é visível para si e para a sua equipa.",
        "internal_info": "Informações internas",
        "keepHidden": "Manter escondido",
        "keep_synced_proposals": "Manter as propostas sincronizadas para que se tornem uma proposta autónoma.",
        "link_to_template": "Ligação ao modelo?",
        "link_to_template_after_create": "Ligar imediatamente esta proposta ao novo modelo após a sua criação.",
        "makeDecision": "Aceitar uma proposta para {decision_name} clicando no botão aprovar",
        "margin": "Margem",
        "marginBudget%": "Orçamento da margem ({margem}%)",
        "marginSurcharge%": "Sobretaxa de margem ({margem}%)",
        "marginSurchargesExtraBudget%": "Margem extra orçamento + sobretaxa ({margem}%)",
        "new": "Criar uma nova proposta",
        "noImage": "Nenhuma imagem",
        "no_budget_available_yet": "Não aplicável",
        "no_documents": "A proposta não contém quaisquer documentos.",
        "no_edit_details": "Esta proposta tem elementos que dependem dela. Contactar o cliente se pretender editar os detalhes",
        "no_edit_details_installments": "Esta proposta tem uma condição de prestação solicitada ou paga. Para editar os detalhes, altere a condição de prestação ligada para o estado projeto. Ir para {link}.",
        "no_edit_details_installments_link": "finanças",
        "no_edit_documents": "Quando uma proposta é aprovada, os documentos não podem ser editados.",
        "notApplicable": "Não aplicável",
        "notDefined": "Não definido",
        "notSeenYetByCustomer": "Ainda não visto pelo cliente",
        "notSelectedYet": "Seleccione as suas escolhas para ver o total",
        "notSharedYet": "Ainda não partilhado",
        "not_approved_yet": "Esta proposta ainda não foi aprovada.",
        "not_interested_reset_header": "Decisão marcada como não interessada",
        "not_interested_reset_message": "Esta decisão está atualmente marcada como 'Não interessado'. A criação de uma proposta irá redefinir o estado 'Não interessado'.",
        "only_visible_team_partners": "Apenas visível para a equipa",
        "other": "Outros",
        "proposalFor": "Proposta de",
        "proposal_template_sync_note": "Fazer alterações em um modelo de proposta atualiza todas as propostas sincronizadas e não aprovadas.",
        "proposal_unapprove_not_possible": "Não é possível anular a aprovação",
        "proposalsApproved": "Propostas aprovadas",
        "proposalsOther": "Outras propostas",
        "relaunch": "Proposta de relançamento",
        "request_changes": {
          "body": "Por favor, forneça alguns comentários adicionais sobre o que deve ser alterado na presente proposta",
          "feedback": "Feedback",
          "title": "Pedir alterações"
        },
        "requested_changes": "Alterações solicitadas",
        "requiresSignature": "Necessidade de assinar documentos",
        "seenByCustomer": "Visto pelo cliente:",
        "selectUnitsShare": "Selecionar unidades com as quais partilhar o modelo",
        "shareCustomerDescription": "Esta proposta está associada a uma decisão que ainda não foi partilhada com o cliente. Pretende partilhar também a decisão para que o cliente possa ver esta proposta imediatamente?",
        "shareCustomerTitle": "Partilhar a decisão com o cliente?",
        "shareDecision": "Partilhar decisão",
        "shareExtraAlert": "A decisão também será partilhada assim que clicar em enviar",
        "sharePartnerTitle": "Partilhar a decisão com o parceiro?",
        "sharePartnersDescription": "Esta proposta está associada a uma decisão que ainda não foi partilhada com o parceiro. Pretende partilhar também a decisão para que o parceiro possa ver esta proposta imediatamente?",
        "sharedWith": "Partilhado com",
        "showAndEditDetails": "Mostrar e editar detalhes",
        "single_approval_warning": {
          "message": "Pode continuar a criar propostas, mas o cliente só pode aprovar uma proposta. Contacte o seu administrador para ativar a aprovação de múltiplas propostas.",
          "title": "Aviso: Apenas uma proposta pode ser aprovada"
        },
        "skip_customer": "O projeto ignora a etapa do cliente.",
        "surcharges": "Actualizações",
        "surcharges_extra": "Actualizações adicionais",
        "synced_with_template": "Sincronizado com o modelo de proposta",
        "synced_with_units": "Sincronizado com 1 unidade | Sincronizado com {unit_count} unidades",
        "template_accept_confirm": "<p>Esta proposta está sincronizada com um modelo de proposta. Quando aceitar esta proposta, a sincronização será interrompida e esta proposta deixará de ser actualizada quando o modelo de proposta for atualizado.</p></br><p>Tem a certeza de que pretende aceitar esta proposta?</p>",
        "template_edit_confirm": "<p>Esta proposta está sincronizada com um modelo de proposta. Quando você editar esta proposta, a sincronização será interrompida e esta proposta não será mais atualizada quando o modelo de proposta for atualizado.</p></br><p>Tem certeza de que deseja continuar editando esta proposta?",
        "totalBudget": "Orçamento total",
        "totalNetOffer": "Oferta líquida total",
        "total_excl_vat": "Total sem IVA",
        "total_incl_vat": "Total com IVA",
        "total_vat": "Total IVA",
        "typeToShare": "Tipo de proposta a partilhar",
        "unit_not_activated": "A unidade não está ativada.",
        "uploadDocuments": "Carregar documentos assinados",
        "uploadSignedDocument": "Ou carregar um documento assinado",
        "vat_excl": "sem IVA",
        "vat_excl_with_number": "excl. {vat} IVA%",
        "visibleForCustomer": "Visível para o cliente",
        "writeEmployeeNameAccept": "Escrever <i><b>{employeeName}</b></i> para aceitar esta proposta.",
        "writeEmployeeNameDelete": "Escreva <i><b>{employeeName}</b></i> para eliminar esta proposta.",
        "writeEmployeeNameReject": "Escrever <i><b>{employeeName}</b></i> para anular a aprovação desta proposta."
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Em breve encontrarão aqui uma proposta para aprovar",
            "title": "Ainda não há propostas para decisão {decision_name} "
          }
        },
        "employees": {
          "new": {
            "subtitle": "Proponha uma ou mais ofertas e deixe o seu cliente decidir.",
            "title": "Criar uma proposta"
          },
          "proposalNotice": "Importante: só pode ser aprovada uma proposta. Pode sempre editar uma proposta existente e acrescentar novos documentos.",
          "template": {
            "subtitle": "Quando se criam propostas em massa, estas aparecem aqui",
            "title": "Ainda não foram criados modelos de proposta."
          }
        },
        "partners": {
          "new": {
            "subtitle": "Proponha uma ou mais ofertas e deixe o cliente decidir.",
            "title": "Criar uma proposta"
          },
          "proposalNotice": "Importante: só pode ser aprovada uma proposta. É sempre possível editar uma proposta existente e adicionar novos documentos. Se uma proposta já tiver sido aprovada, um membro da equipa pode anulá-la antes de acrescentar documentos adicionais."
        }
      },
      "toasts": {
        "convert": "Proposta convertida com êxito em modelo",
        "create": "Proposta criada com sucesso",
        "delete": "Proposta eliminada com êxito",
        "shareSuccess": "Propostas partilhadas com êxito",
        "update": "Proposta actualizada com êxito"
      },
      "validation": {
        "amountNotUpdatable": "O montante não pode ser atualizado: algumas prestações dependem dele",
        "choice_list": {
          "needChoice": "Esta lista de opções precisa de pelo menos 1 opção",
          "needSelection": "Esta opção requer um item selecionado"
        },
        "choices": {
          "lessThanOrEqual": "O número tem de ser menor ou igual a {max_number}",
          "needPriceItem": "É necessário um preço por artigo",
          "needSelection": "Seleção necessária",
          "needVatPercentage": "É necessária uma percentagem de IVA",
          "quantityBetween": "A quantidade deve estar compreendida entre {quantity_min} e {quantity_max}",
          "quantityNotZero": "A quantidade tem de ser, pelo menos, 1",
          "quantityRequired": "A quantidade é necessária",
          "uniqueNames": "Os nomes devem ser únicos"
        },
        "nameNotCorrect": "O nome é obrigatório e tem de corresponder",
        "needName": "O título é obrigatório",
        "needNumber": "Deve ser um número (por exemplo, 85)",
        "need_request_changes_note": "Dê a sua opinião sobre o seu pedido de alteração",
        "readAllDocuments": "Certifique-se de que leu todos os documentos",
        "requiresSignature": "Marque pelo menos um documento em que o cliente tenha de assinar eletronicamente. Desactive a opção abaixo se não necessitar de assinaturas.",
        "share": {
          "needSelection": "Selecionar alguém com quem partilhar a proposta | Selecionar alguém com quem partilhar as propostas",
          "needType": "Selecionar o(s) tipo(s) de proposta"
        },
        "uploadAtLeast1Document": "Carregar pelo menos um documento assinado"
      }
    }
  }
}
